<template>
  <div class="container" v-if="shareShow" @click.self="onClose">
    <div class="box" v-if="step === 1">
      <img
        class="img"
        src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/buka_bkg.png"
        alt
      />
      <div class="title">
        剩余补签卡：
        <div>{{dakaInfo.helpCount - dakaInfo.helpUsedCount}}</div>
      </div>
      <div class="tip">
        分享给新用户，新用户注册登录后您会
        得到1次补卡机会，您还可以获得{{ dakaInfo.helpTotalCount - dakaInfo.helpCount }}次补签卡
      </div>
      <div
        class="bottom_box"
        v-if="dakaInfo.helpTotalCount - dakaInfo.helpCount > 0 || dakaInfo.helpCount - dakaInfo.helpUsedCount > 0"
      >
        <div class="btn1" @click="onClose">取消</div>
        <div
          class="btn2"
          v-if="dakaInfo.helpCount - dakaInfo.helpUsedCount > 0"
          @click="onSubmit"
        >确认补卡</div>
        <div class="btn2" v-else @click="onBoostShare">去分享</div>
      </div>
      <div class="bottom_box" v-else>
        <div class="btn2" @click="onClose">我知道了</div>
      </div>
    </div>
    <div class="code_box" v-else>
      <div class="content" id="shareCodeImg" v-if="!shareUrl">
        <img
          class="img"
          src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/buka_share_bkg.png"
          alt
          crossorigin="Anonymous"
        />
        <div id="share_qrcode"></div>
      </div>
      <img class="content" v-else :src="shareUrl" alt />
    </div>
  </div>
</template>

<script>
import html2canvas from 'html2canvas';
import loadJS from 'load-js';

export default {
  props: {
    shareShow: {
      type: Boolean,
      default: false,
    },
    dakaInfo: {
      type: Object,
      default: () => {},
    },
    userInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      step: 1,
      shareUrl: '',
    };
  },
  methods: {
    onClose() {
      this.step = 1;
      this.shareUrl = '';
      this.$emit('onShareModalClose');
    },
    onBoostShare() {
      // 测试用
      // this.$emit('onBukaSubmit');
      // return
      // this.$emit('onBoostShare');
      this.step = 2;
      loadJS([
        {
          async: false,
          url: 'https://image-prod.iqihang.com/public/js/qrcode.min.js',
        },
      ]).then(() => {
        this.creatQrCode();
      });
    },
    onSubmit() {
      this.$emit('onBukaSubmit');
    },
    creatQrCode() {
      if (this.isCreatQrCode) return;
      this.isCreatQrCode = true;
      const url = `${window.location.origin}/ark/checkHelp?p=${this.dakaInfo.activityId}&u=${this.userInfo.id}&isPreview=0&check=true`;
      console.log('创建二维码', url);
      // eslint-disable-next-line no-new, no-undef
      new QRCode(document.getElementById('share_qrcode'), {
        text: url,
        render: 'table',
        // render:"canvas",
        width: 145,
        height: 145,
        typeNumber: -1, // 计算模式
        correctLevel: 0, // 纠错等级   correctLevel
      });
      console.log('创建二维码成功了', document.getElementById('share_qrcode'));

      setTimeout(() => {
        html2canvas(document.getElementById('shareCodeImg'), {
          dpi: 300,
          useCORS: true,
          backgroundColor: 'transparent', // 圆角问题
        }).then(canvas => {
          const dataURL = canvas.toDataURL('image/png', 1.0);
          this.shareUrl = dataURL;
        });
        setTimeout(() => {
          this.isCreatQrCode = false;
        }, 1000);
      }, 600);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 7;
  height: 100vh;
  width: 750px;
  background: rgba($color: #000000, $alpha: 0.7);

  .box {
    height: 670px;
    width: 634px;
    position: absolute;
    top: 406px;
    left: 58px;
    background: #ffffff;
    border-radius: 36px;
    overflow: hidden;

    .img {
      display: block;
      height: 297px;
      width: 634px;
    }

    .title {
      height: 76px;
      display: flex;
      justify-content: center;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 36px;
      color: #333333;
      line-height: 76px;

      div {
        font-weight: 600;
        font-size: 54px;
        color: #ff7f41;
      }
    }
    .tip {
      width: 431px;
      height: 80px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 25px;
      color: #333333;
      line-height: 40px;
      margin: 22px auto 0;
      text-align: center;
    }

    .bottom_box {
      height: 80px;
      margin: 58px auto 0;
      display: flex;
      justify-content: center;
      gap: 18px;
      font-weight: 500;
      font-size: 29px;
      line-height: 80px;
      .btn1 {
        width: 272px;
        height: 80px;
        border-radius: 45px;
        border: 2px solid #ff7f41;
        color: #ff7f41;
        text-align: center;
      }
      .btn2 {
        width: 272px;
        height: 80px;
        border-radius: 45px;
        background: #ff7f41;
        color: #ffffff;
        text-align: center;
      }
    }
  }

  .code_box {
    position: absolute;
    height: 800px;
    width: 630px;
    top: 410px;
    left: 60px;

    .content {
      display: block;
      position: relative;
      height: 100%;
      width: 100%;

      .img {
        position: absolute;
        z-index: 1;
        display: block;
        height: 800px;
        width: 630px;
        top: 0;
        left: 0;
      }
      #share_qrcode {
        position: absolute;
        z-index: 3;
        display: block;
        height: 290px;
        width: 290px;
        top: 330px;
        left: 170px;
        img {
          height: 100%;
          width: 100%;
        }
      }
    }
  }
}
</style>